import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { affiliateAuthAPI, affiliatePortalAPI } from '../services/affiliateApi';

const AffiliateAuthContext = createContext(null);

export const AffiliateAuthProvider = ({ children }) => {
  const [affiliate, setAffiliate] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    localStorage.removeItem('affiliateToken');
    localStorage.removeItem('affiliateUser');
    setAffiliate(null);
    window.location.href = '/affiliate/login';
  }, []);

  const setAuthData = useCallback((token, affiliateData) => {
    localStorage.setItem('affiliateToken', token);
    localStorage.setItem('affiliateUser', JSON.stringify(affiliateData));
    setAffiliate(affiliateData);
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await affiliateAuthAPI.login({ email, password });
    setAuthData(data.token, data.affiliate);
    return data;
  }, [setAuthData]);

  const refreshAffiliate = useCallback(async () => {
    try {
      const { data } = await affiliatePortalAPI.getMe();
      setAffiliate(data.affiliate);
    } catch {
      logout();
    }
  }, [logout]);

  useEffect(() => {
    const token = localStorage.getItem('affiliateToken');
    if (!token) { setLoading(false); return; }
    affiliatePortalAPI.getMe()
      .then(({ data }) => setAffiliate(data.affiliate))
      .catch(() => { localStorage.removeItem('affiliateToken'); })
      .finally(() => setLoading(false));
  }, []);

  return (
    <AffiliateAuthContext.Provider value={{ affiliate, loading, login, logout, setAuthData, refreshAffiliate }}>
      {children}
    </AffiliateAuthContext.Provider>
  );
};

export const useAffiliateAuth = () => {
  const ctx = useContext(AffiliateAuthContext);
  if (!ctx) throw new Error('useAffiliateAuth must be used within AffiliateAuthProvider');
  return ctx;
};

export default AffiliateAuthContext;
